import { Component, OnInit } from '@angular/core';
import { RecipeService } from '../service/recipe.service';
import { Auth } from 'aws-amplify';
import { RecipeWrapper } from '../entities/RecipeWrapper';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-default-machine',
  templateUrl: './default-machine.component.html',
  styleUrls: ['./default-machine.component.css']
})
export class DefaultMachineComponent implements OnInit {

  accessToken: Object;
  recipes: RecipeWrapper[];
  error: String;
  isLoading; Boolean;
  modalDisplay: any;
  downloadJsonHref: any;

  constructor(private service: RecipeService, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {

    this.isLoading = true;

    Auth.currentSession().then(res => {

      this.accessToken = res.getAccessToken().getJwtToken();

      this.service.getMachineDefaultRecipes(this.accessToken).subscribe(
        data => {
          this.recipes = <RecipeWrapper[]>data;
          this.isLoading = false;
        },
        error => {
          this.error = error.error.message;
          this.isLoading = false;
        }
      )

      this.service.getMachineDefaultRecipes(this.accessToken).subscribe(
        data => {
          var theJSON = JSON.stringify(data);
          var uri = this.sanitizer.bypassSecurityTrustUrl("data:text/json;charset=UTF-8," + encodeURIComponent(theJSON));
          this.downloadJsonHref = uri;
        },
        error => {
          this.error = error.error.message;
        }
      )
    })

  }

  deleteRecipe(id: number) {
    this.service.deleteDefaultRecipe(this.accessToken, id).subscribe(
      data => {
        var btnId = "delete-close-confirm-btn" + id;
        let element: HTMLElement = document.querySelector('button[id="' + btnId + '"]') as HTMLElement;
        element.click();
        this.ngOnInit();
      },
      error => {
        var btnId = "delete-close-confirm-btn" + id;
        this.error = error.error.message;
        let element: HTMLElement = document.querySelector('button[id="' + btnId + '"]') as HTMLElement;
        element.click();
        this.ngOnInit();
      }
    )

  }

  download() {
    Auth.currentSession().then(res => {

      this.accessToken = res.getAccessToken().getJwtToken();

      this.service.getMachineDefaultRecipes(this.accessToken).subscribe(
        data => {
          this.recipes = <RecipeWrapper[]>data;
          this.isLoading = false;
        },
        error => {
          this.error = error.error.message;
          this.isLoading = false;
        }
      )
    })

  }

}
